/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalibrationControllerService {
    /**
     * @param scheduleUuid
     * @param randomRuns
     * @param includeManualSequences
     * @returns any OK
     * @throws ApiError
     */
    public static runCalibration(
        scheduleUuid: string,
        randomRuns: number = 5,
        includeManualSequences: boolean = true,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/calibration/run/{scheduleUuid}',
            path: {
                'scheduleUuid': scheduleUuid,
            },
            query: {
                'randomRuns': randomRuns,
                'includeManualSequences': includeManualSequences,
            },
        });
    }
    /**
     * @param jobId
     * @returns any OK
     * @throws ApiError
     */
    public static getStatus(
        jobId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/calibration/status/{jobId}',
            path: {
                'jobId': jobId,
            },
        });
    }
}
